import { apiCall } from './config';
import { sessionManager } from './sessionManager';

// Login API call
export const loginUser = async (email, password) => {
  return apiCall('/login.php', {
    method: 'POST',
    body: JSON.stringify({
      email,
      password,
    }),
  });
};

// Logout - clear all session data
export const logoutUser = () => {
  console.log('🔓 Logging out...');
  sessionManager.clear();
};

// Get stored auth token
export const getAuthToken = () => {
  console.log('🔑 Retrieving auth token...');
  return sessionManager.getToken();
};

// Get stored user info
export const getUserInfo = () => {
  console.log('👤 Retrieving user info...');
  return sessionManager.getUser();
};

// Check if user is authenticated
export const isUserAuthenticated = () => {
  console.log('🔐 Checking authentication status...');
  return sessionManager.isAuthenticated();
};
